<div class="cph-container">
    <app-table-component
        [data]="paymentTransactionsList()"
        [columns]="tableColumns"
        [totalRecords]="totalRecords()"
        [rows]="rows"
        [first]="first"
        (pageChange)="onPageChange($event)"
        [showSearch]="false"
        [showColumnSelector]="false"
        [showClearFilters]="false"
        [customFilters]="[createdDateFilter]" />
</div>